import React from 'react'

import { DynamicProfileFormScreen } from '../DynamicProfileFormScreen'

export const CreateDynamicProfileFormScreen = () => {
  return (
    <DynamicProfileFormScreen variant='create' />
  )
}